import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/variables.css'
import './styles/global.css'
import './styles/landing.css'
// Logger centralizado: suprime console.log en producción para no-admins.
// Este import debe ser el primero para ejecutar el override desde el inicio.
import './utils/logger.js'
// Aplicar tamaño de texto guardado
import { getTextSize, applyTextSize } from './utils/textSize';
applyTextSize(getTextSize());

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Registrar Service Worker para PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    if (import.meta.env.DEV) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(registration => registration.unregister()));
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.filter(key => key.startsWith('vortex-')).map(key => caches.delete(key)));
      }
      return;
    }

    try {
      const registration = await navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' });
      console.log('SW registrado con éxito:', registration.scope);

      // Manejar actualizaciones
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // Nueva versión disponible
              console.log('[SW] Nueva versión disponible');
              // Disparar evento personalizado para notificar a la app
              window.dispatchEvent(new CustomEvent('swUpdateAvailable', { detail: registration }));
            }
          });
        }
      });

      // Verificar actualizaciones periódicamente
      setInterval(() => registration.update(), 60 * 60 * 1000); // cada hora

    } catch (error) {
      console.log('Fallo en registro de SW:', error);
    }
  });
}